import { type UseQueryOptions, useQuery } from "@tanstack/react-query"
import type { TSessionStats } from "@/types/activities"
import { sessionsAPI } from "@/utils"

export function useAPISessionsMeta({
  limit,
  offset,
  sort,
  where,
  ...props
}: Parameters<typeof sessionsAPI.stats>[0] & Omit<UseQueryOptions<TSessionStats[]>, "queryKey"> = {}) {
  return useQuery({
    queryKey: ["sessions-meta", where, sort, limit, offset],
    queryFn: () => sessionsAPI.stats({ where, sort, limit, offset }),
    ...props,
  })
}
